/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext } from 'react';
import type { ISecodaEditor } from '.';

export const SecodaEditorContext = createContext<ISecodaEditor | null>(null);

export function SecodaEditorProvider({
	children,
	editor,
}: {
	children: React.ReactNode;
	editor: ISecodaEditor;
}) {
	return (
		<SecodaEditorContext.Provider value={editor}>
			{children}
		</SecodaEditorContext.Provider>
	);
}

export function useSecodaEditor() {
	const context = useContext(SecodaEditorContext);
	if (!context) {
		throw new Error(
			'useSecodaEditor must be used within a SecodaEditorProvider'
		);
	}
	return context;
}
